import React from "react";
import { useNavigate } from 'react-router-dom';
import "./landing.css";
// import "../login/login.css"
import headerImage from "../../assets/images/MysticTan_Unity_Logo_White.png"
import SquareButton from "../../components/squareButton/squareButton";
import { useTranslation } from 'react-i18next';
const App = () => {
  const letsGo = useNavigate();
  const { t } = useTranslation("translation", { keyPrefix: "landing" });
  return (

    <div className="landing-container">
      <div className="header-image"><img src={headerImage}></img></div>
      <div className="landing-content">
        <h1 className="landing-text">{t("landingtext", "Sign up or login to start customizing your treatment")}</h1>
        <div className="landing-buttons">
          <SquareButton className='landing-btn-left' onClick={() => letsGo("/login")}>{t("login", "LOGIN")}</SquareButton>
          <SquareButton className='landing-btn-right' onClick={() => letsGo("/accountcreate")}>{t("signup", "SIGN UP")}</SquareButton>
        </div>
      </div>
    </div>
  );
};

export default App;

